import { useState } from "react";

interface UseTimeChangeReturn {
  handleTimeChange: (visibleTimeStart: number, visibleTimeEnd: number) => void;
  visibleTimeStart: number;
  visibleTimeEnd: number;
}

interface UseTimeChange {
  minTime: number;
  maxTime: number;
}

export default function useTimeChange({
  minTime,
  maxTime,
}: UseTimeChange): UseTimeChangeReturn {
  const [visibleTimeStart, setVisibleTimeStart] = useState(minTime);
  const [visibleTimeEnd, setVisibleTimeEnd] = useState(maxTime);

  const handleTimeChange = (timeStart: number, timeEnd: number): void => {
    if (timeStart < minTime && timeEnd > maxTime) {
      setVisibleTimeStart(minTime);
      setVisibleTimeEnd(maxTime);
    } else if (timeStart < minTime) {
      setVisibleTimeStart(minTime);
      setVisibleTimeEnd(minTime + (timeEnd - timeStart));
    } else if (timeEnd > maxTime) {
      setVisibleTimeStart(maxTime - (timeEnd - timeStart));
      setVisibleTimeEnd(maxTime);
    } else {
      setVisibleTimeStart(timeStart);
      setVisibleTimeEnd(timeEnd);
    }
  };

  return { visibleTimeStart, visibleTimeEnd, handleTimeChange };
}
